// const { Space, Form, Input } = require("antd");
import styled from "styled-components"
import { Space, Form, Input } from "antd"
import { useNavigate } from "react-router-dom";
import { forwardRef, useEffect } from "react";
import axios from "axios";

const backend = process.env.REACT_APP_BACKEND;
const StyledSpace = styled((props)=><Space direction="vertical" size={0} {...props}/>)`
  &&& {
    display: flex;
    flex-direction: column;
    flex-grow:1;
    overflow: auto;

    & > .ant-space-item {
      overflow: auto;
    }
  }
`

function ImageTabRightPromptLastestPrompt ({rightBox}, promptRef) {

  const navigate = useNavigate()

  useEffect(()=>{
    const WordExMaster_id = rightBox[1].id
    axios.get(`${backend}/contents/new_word/image/last-text/${WordExMaster_id}`)
    .then(res=>{
      const promptText = res.data.data[0]?.prompt_text
      promptRef.current.setFieldValue("prompt_text",promptText)
    })
    .catch(err=>{
      console.log(err);
      if(err.response && err.response.status===401) {
        navigate("/auth")
      }
    })
  },[rightBox[1].id])

  return (
    <StyledSpace>
      <Form ref={promptRef}>
        <Form.Item name="prompt_text" style={{margin: "0px 0px 10px"}}>
          <Input.TextArea autoSize style={{minHeight: 100}}></Input.TextArea>
        </Form.Item>
      </Form>
      
    </StyledSpace>
  )
}

export default forwardRef(ImageTabRightPromptLastestPrompt)